import { useContext, useMemo } from "react";
import { AccountContext } from "../context/account";

export default function useLoggedIn(): boolean {
  const { account } = useContext(AccountContext);

  return useMemo(() => {
    return !!(account?.checked && account?.loggedIn);
  }, [account?.checked, account?.loggedIn]);
}